/*
    Copyright 2016-2017, PE4H, Inc

 */

// Set to debug for normal development.
var environments = {
  development: 1,
  testing: 2,
  demo: 3,
  production: 4
};

/*==================================================================================
 *==================================================================================
 * SET THESE VARIABLES TO THE ELASTIC BEANSTALK UPLOAD VERSION
 * AND THE DESIRED ENVIRONMENT.
 */
var includeversion = 1;
var currentEnvironment = environments["production"];
//==================================================================================
//==================================================================================

// Local development (default when currentEnvironment is not production or staging).
var baseApiUrl = "https://apidev.pe4h.com/api";//"http://localhost:2101/api"; //"http://192.168.0.200:12345/api"; //"https://apidev.pe4h.com/api" //;
var baseSiteUrl = "https://dev.pe4h.com/"; //"https://dev.pe4h.com/";
var assetsUrl = "https://s3-us-west-2.amazonaws.com/pe4hdev/";
var stripePublicKey = "pk_test_lFp6rN8kmoJb03o5nTU4Pg3p"; // TODO: Get/Define public keys for production
var baseEscrowUrl = "https://www.escrow-sandbox.com";

if (currentEnvironment == environments.testing) {
  // Staging
  baseApiUrl = "https://apidev.pe4h.com/api";
  baseSiteUrl = "https://dev.pe4h.com/";
  stripePublicKey = "pk_test_lFp6rN8kmoJb03o5nTU4Pg3p";
  assetsUrl = "https://s3-us-west-2.amazonaws.com/pe4hdev/";
  //baseEscrowUrl = "https://www.escrow.com";
} else if (currentEnvironment == environments.demo) {
  // demo
  baseApiUrl = "";
  baseSiteUrl = "";
  stripePublicKey = "";
  assetsUrl = "https://s3-us-west-2.amazonaws.com/pe4hdev/";
} else if (currentEnvironment == environments.production) {
  // Production
  baseApiUrl = "https://api.peforhire.com/api";
  baseSiteUrl = "https://www.peforhire.com/";
  stripePublicKey = "pk_live_QOKxpYEBYACl2YX8onheA3uP";
  assetsUrl = "https://s3-us-west-2.amazonaws.com/pe4hprod/";
  baseEscrowUrl = "https://www.escrow.com";
}

function parseRoute(route, params, baseUrl) {
  for (k in params) {
    route = route.replace("{" + k + "}", params[k]);
  }
  if(baseUrl)
    return baseUrl + route;
  else
    return baseApiUrl + route;
}

window.configuration = {
  htmlIncludeVersion: includeversion,
  stripePublicKey: stripePublicKey,

  debug: {
    isDebug: currentEnvironment != environments.production,
    isDevEnvironment: currentEnvironment == environments.development,
    alertErrors: true
  },

  pe4hUrl: baseSiteUrl,
  assetsUrl: assetsUrl,

  googleApiKey: "AIzaSyBhUA7ChLHXS1g5AT1kUbHUoVIQzEvM89w",
  escrowDisbursementMethodURL: function(obj){
    paymentUrl = "/login-page?loginLocation=%2Fmyescrow%2FSettlementPaymentChoice.asp%3FTID%3D{transactionId}";
    return parseRoute(paymentUrl, obj, baseEscrowUrl);
  },

  webApi: {
    about: {
      contact_us: baseApiUrl + "/about/contactus/"
    },
    auth: {
      login: baseApiUrl + "/auth/login/",
      token: baseApiUrl + "/auth/token/",
      change_password: baseApiUrl + "/auth/changepassword/",
      reset_password: baseApiUrl + "/auth/resetpassword/",
      confirm_reset_password: baseApiUrl + "/auth/confirmresetpassword/",
      validate_reset_password: baseApiUrl + "/auth/validateResetPasswordToken"
    },
    users: {
      client: baseApiUrl + "/users/client/",
      professional: baseApiUrl + "/users/professional/",
      reviews: function (obj) {
        return parseRoute("/users/{id}/reviews/", obj);
      },
      projecthistory: function (obj) {
        return parseRoute("/users/{id}/projecthistory/", obj);
      },
      users: baseApiUrl + "/users/",
      picture: baseApiUrl + "/users/picture/",
      licenses: function (obj) {
        return parseRoute("/users/{id}/licenses/", obj);
      },
      users_id: function (obj) {
        return parseRoute("/users/{id}/", obj);
      },
      requests: baseApiUrl + "/users/requests/",
      wrequests: baseApiUrl + "/users/wrequests/",
      exists: baseApiUrl + "/users/exists/",
      exists_detailed: baseApiUrl + "/users/exists_detailed/",
      engineers: function (obj) {
        return parseRoute(
          "/users/engineers?state={state}&licenseId={licenseId}&pageSize={pageSize}&currentPage={currentPage}",
          obj
        );
      },
      engineer: function (obj) {
        return parseRoute(
          "/users/engineers/{id}",
          obj
        );
      },
      getVerificationLink: function(obj){
        return parseRoute("/users/{id}/verificationLink/", obj);
      }
    },
    licenses: {
      licenses: baseApiUrl + "/licenses/",
      information: baseApiUrl + "/licenses/information"
    },
    popUpMessages: {
      messages: baseApiUrl + "/messages"
    },
    projects: {
      projects: baseApiUrl + "/projects/",
      publicProjects: function (obj) {
        return parseRoute(
          "/publicprojects?state={state}&licenseId={licenseId}&pageSize={pageSize}&currentPage={currentPage}",
          obj
        );
      }, projects_uid: function (obj) {
        return parseRoute("/projects/{uid}", obj);
      },
      hide: function (obj) {
        return parseRoute("/projects/{id}/hide", obj);
      },
      proposals: function (obj) {
        return parseRoute("/projects/{id}/proposals", obj);
      },
      client: function (obj) {
        return parseRoute("/projects/{id}/client", obj);
      },
      close: function (obj) {
        return parseRoute("/projects/{id}/close", obj);
      },
      requestProposal: function (id, engId) {
        return parseRoute("/projects/{id}/requestproposal/{engId}", id, engId)
      },
      paymentInformation: function (id) {
        return parseRoute("/projects/{id}/fund", id);
      },
      confirmPayment: function (id) {
        return parseRoute("/projects/{id}/confirmPayment", id);
      },
      paymentSubmitted: baseApiUrl + "/projects/paymentSubmitted",
      releaseFunds: function(id){
        return parseRoute("/projects/{id}/releaseFunds", id);
      }
    },
    proposals: {
      proposals: baseApiUrl + "/proposals/",
      proposals_id: function (obj) {
        return parseRoute("/proposals/{id}/", obj);
      },
      proposals_id_professional: function (obj) {
        return parseRoute("/proposals/{id}/professional/", obj);
      },
      proposals_id_client: function (obj) {
        return parseRoute("/proposals/{id}/client/", obj);
      },
      proposals_project_id_exists: function (obj) {
        return parseRoute("/proposals/{projectId}/exists/", obj);
      },
      id_hire: function (obj) {
        return parseRoute("/proposals/{id}/hire/", obj);
      },
      proposals_id_message: function (obj) {
        return parseRoute("/proposals/{id}/message/", obj);
      },
      id_review: function (obj) {
        return parseRoute("/proposals/{id}/review/", obj);
      },
      request_release_of_funds: function(obj){
        return parseRoute("/proposals/{id}/requestReleaseOfFunds/", obj);
      }
    },
    questions: {
      list: function (obj) {
        return parseRoute("/questions/{projectId}/", obj);
      },
      detail: function (obj) {
        return parseRoute("/questions/{projectId}/{questionId}/", obj);
      },
      markProjectAsRead: function (obj) {
        return parseRoute("/questions/{projectId}/last_seen", obj)
      }
    },
    invoices: {
      invoices: baseApiUrl + "/invoices/",
      calculateFee: baseApiUrl + "/invoices/calculateFee",
      requestInvoice: function(obj){
        return parseRoute("/invoices/{projectId}/requestInvoice", obj);
      },
      sendInvoice: function (obj) {
        return parseRoute("/invoices/{proposalId}/sendInvoice", obj);
      },
      resendInvoice: function(obj) {
        return parseRoute("/invoices/{id}/resendInvoice", obj);
      },
      getPendingInvoice: function (obj) {
        return parseRoute("/invoices/pending/{projectId}", obj);
      },
      getLastRejectedInvoice: function (obj) {
        return parseRoute("/invoices/lastRejected/{proposalId}", obj);
      },
      approveInvoice: function (obj) {
        return parseRoute("/invoices/{projectId}/approveInvoice", obj);
      },
      rejectInvoice: function (obj) {
        return parseRoute("/invoices/{projectId}/rejectInvoice", obj);
      },
      requestRevisedInvoice: function(obj) {
        return parseRoute("/invoices/{projectId}/requestRevisedInvoice", obj);
      }
    },
    escrowTransactions: {
      getByProposalId: function(obj){
        return parseRoute("/escrowTransaction/{proposalId}", obj);
      }
    },
    states: {
      states: baseApiUrl + "/states/"
    },
    zipcodes: {
      exists: function (obj) {
        return parseRoute("/zipcodes/{code}/exists/", obj);
      }
    }
  },
  status_to_hide_contact_info_to:{
    client: "open",
    engineer: "submitted"
  },
  status_action: {
    proposal: {
      hired: {
        action_name: "Send Invoice",
        action_id: "send-invoice"
      },
      invoiceSent: {
        action_name: "Resend Invoice",
        action_id: "resend-invoice"
      },
      invoiceRejected: {
        action_name: "Send Revised Invoice",
        action_id: "send-revised-invoice"
      },
      invoiceApproved: {
        action_name: "Complete Escrow Setup",
        action_id: "complete-escrow-setup"
      },
      paymentSubmitted: {
        action_name: "Complete Escrow Setup",
        action_id: "complete-escrow-setup"
      },
      escrowFundedDisReq:{
        action_name: "Select Disbursement Method",
        action_id: "select-disbursement-method"
      },
      escrowFunded: {
        action_name: "Request Release of Funds",
        action_id: "request-release-of-funds"
      },
      fundsRequested: {
        action_name: "Re-request Release of Funds",
        action_id: "re-request-release-of-funds"
      },
      completedDisReq: {
        action_name: "Select Disbursement Method",
        action_id: "select-disbursement-method"
      }
    },
    project: {
      hired: {
        action_name: "Request an Invoice",
        action_id: "request-an-invoice"
      },
      invoiceReceived: {
        action_name: "Review Invoice",
        action_id: "review-invoice"
      },
      invoiceRejected: {
        action_name: "Request Revised Invoice",
        action_id: "request-revised-invoice"
      },
      awaitingFunds: {
        action_name: "Fund Escrow",
        action_id: "fund-escrow"
      },
      escrowFunded: {
        action_name: "Release Funds",
        action_id: "release-funds"
      },
      fundsReleaseRequested: {
        action_name: "Release Funds",
        action_id: "release-funds"
      }
    }
  },
  verificationStatusName: {
    "not_verified": "Not Verified",
    "pending": "Pending",
    "verified": "Verified"
  },
  default_messages: {
    sendInvoiceMessageBottom: "* This is the total amount you will be paid from Escrow.com\n** Transaction fees billed to the client.",
    sendInvoiceMessageTop: "IMPORTANT! Your invoice must include an itemized list of the specific tasks you will perform and any deliverables you will provide. Your invoice will be rejected if this information is not provided. Update the text box below.",
    sendInvoicePlaceholder: "Example:\n1. Perform structural inspection at 123 Main Street, Anytown USA.\n2. Provide written report to client with findings.\n3. …",
    resendInvoiceMessageBottom: "* This is the total amount you will be paid from Escrow.com\n** Transaction fees billed to the client.",
    resendInvoiceMessageTop: "IMPORTANT! Your invoice must include an itemized list of the specific tasks you will perform and any deliverables you will provide. Your invoice will be rejected if this information is not provided. Update the text box below.",
    resendInvoicePlaceholder: "Example:\n1. Perform structural inspection at 123 Main Street, Anytown USA.\n2. Provide written report to client with findings.\n3. …",
    sendInvoiceConfirmationMessage: "* This is the total amount you will be paid from Escrow.com.\n** Transaction fees billed to the client.",
    sentInvoiceMessage: "Your invoice has been sent to the client. Once the client approves the invoice, funds will be placed into escrow (Escrow.com). Upon completion of the project select the ''Request Release of Funds'' button from your projects dashboard.",
    resentInvoiceMessage: "Your invoice has been sent to the client. Once the client approves the invoice, funds will be placed into escrow (Escrow.com). Upon completion of the project select the 'Request Release of Funds' button from your projects dashboard.",
    reviewInvoiceMessage: "* Transaction fees included.",
    approvedInvoiceMessage: "A transaction has been created through our payment processing platform, Escrow.com. Click ‘Continue’ to log into Escrow.com and make payment. Your payment will be released once the work is complete and you are satisfied. If you do not have an Escrow.com account, you will be asked to create a password and verify your identity for compliance reasons. You may be asked to upload supporting documentation as required by escrow law.",
    rejectedInvoiceMessage: "An email has been sent to the engineer with your comments.",
    verificationPendingMessage: "For compliance reasons Escrow requires you to verify your identity.\nYour Escrow account is being verified, please try again later.",
    verifyEscrowAccountMessage: "For compliance reasons Escrow.com requires you to verify your identity.\nTo verify your identity please click on the link below, fill out the appropiate form and upload the supporting documentation.\nOnce you have submitted your information, escrow verification can take several minutes. You will not be able to fund escrow until this automated process is complete.",
    wireTransferStepsMessage: "Transactions over ${{creditCardLimit}} must be paid via wire transfer to Escrow.com (Internet Escrow Services Inc).\nLog in to your online banking app and complete the wire transfer electronically, or print this page and bring it to your local banking center.\nYou MUST click ‘Confirm Payment’ once the wire transfer has been initiated.",
    confirmWireTransferMessage: "",
    paymentConfirmedMessage: "Funds will be applied to your Escrow.com account shortly. Once the engineer has completed the project and you are satisfied, choose the ‘Release Funds’ button from your P.E. For Hire dashboard.",
    requestReleaseOfFundsMessage: "I certify that all work is now complete per my invoice and agreed upon escrow instructions.",
    requestReleaseOfFundsSentMessage: "An email has been sent to the client for the release of funds from Escrow.\nOnce the funds have been released you will be paid in the manner which you have selected from Escrow.com.",
    reRequestReleaseOfFundsMessage: "I certify that all work is now complete per my invoice and agreed upon escrow instructions.",
    reRequestReleaseOfFundsSentMessage: "An email has been sent to the client for the release of funds from Escrow.\nOnce the funds have been released you will be paid in the manner which you have selected from Escrow.com.",
    releaseOfFundsMessage: "I hereby agree to the release of escrow funds to the engineer.",
    fundsReleasedMessage: "Funds have been released to the engineer. Please take a moment to submit a review for the engineer.",
    requestInvoiceMessage: "A request has been sent to the engineer to submit an invoice for your review.",
    requestRevisedInvoiceConfirmationMessage: "An email has been sent to the engineer.",
    sendRevisedInvoiceMessageBottom: "* This is the total amount you will be paid from Escrow.com\n** Transaction fees billed to the client.",
    sendRevisedInvoiceMessageTop: "IMPORTANT! Your invoice must include an itemized list of the specific tasks you will perform and any deliverables you will provide. Your invoice will be rejected if this information is not provided. Update the text box below.",
    sendRevisedInvoicePlaceholder: "Example:\n1. Perform structural inspection at 123 Main Street, Anytown USA.\n2. Provide written report to client with findings.\n3. …",
    sendRevisedInvoiceConfirmationMessage: "* This is the total amount you will be paid from Escrow.com.\n** Transaction fees billed to the client.",
    sentRevisedInvoiceMessage: "Your invoice has been sent to the client. Once the client approves the invoice, funds will be placed into escrow (Escrow.com). Upon completion of the project select the 'Request Release of Funds' button from your projects dashboard.",
    paymentMethodAlreadySet: "You have already confirmed payment. This process can take several minutes. Once complete, the status of your project will change to ‘Escrow Funded’.",
    proposalSentMessage: "An email with your proposal has been sent to the client. You will be notified if you have been selected.",
    paymentSubmittedMessage: "Funds needs to be approved by Escrow.com. Once the engineer is verified and the payment is approved, the status of your project will change to ‘Escrow Funded’.",
  },

  // Andles api error and returns an object as
  // {code, message, messageList, detail}
  // Where code and detail are original error fields
  // message will only contain a value if the error can be represented as a single message
  // and messageList will be a list of all possible error messages without the keys
  processError: function (data) {
    var res = {
      code: null,
      detail: null,
      message: null,
      messageList: null
    };

    var getStringRecursive = function (data, messageList) {
      if (typeof data == "string") {
        messageList.push(data);
      } else if (typeof data == "object") {
        // if list, iterate over list
        if (data.length) {
          for (var i = 0; i < data.length; i++) {
            getStringRecursive(data[i], messageList);
          }
        } else {
          // else iterate over keys
          for (var k in data) {
            getStringRecursive(data[k], messageList);
          }
        }
      } else if (data != null) {
        messageList.push(data.toString());
      }
    };

    if (data) {
      (res.code = data.Code), (res.detail = data.Detail);

      if (typeof data.Detail == "string" || data.Detail == null) {
        res.message = data.Detail;
      } else {
        res.messageList = [];
        getStringRecursive(data.Detail, res.messageList);
      }
    } else {
      res.message = "Unknown error.";
    }

    return res;
  }
};
